import React from 'react';
import Card from "../../../components/ui/Card";
import DOMPurify from "dompurify";

export default function OfferDisplay({ offer, criteria }) {
    const sumScore = offer.criteria.reduce((total, criterion) => {
        const value = criterion.score;
        return total + (typeof value === "number" ? value : 0);
    }, 0);

    const sumPonderation = criteria.reduce((total, criterion) => {
        const value = criterion.weightingRate;
        return total + (typeof value === "number" ? value : 0);
    }, 0);

    return (
        <div className="flex-col space-y-4">
            {criteria.map((criterion, index) =>
                criterion.name
                    ? (
                        <Card key={criterion.uuid} title={criterion.name}>
                            <p className="text-gray-900">
                                <span className="font-semibold">Score : </span>
                                {offer.criteria[index]?.score != null
                                    ? (
                                        <span className={`${offer.criteria[index].score > criterion.weightingRate && "text-red-600"}`}>
                                            {offer.criteria[index].score}
                                            /
                                            {criterion.weightingRate}
                                        </span>
                                    )
                                    : <span className="text-red-600 italic">aucun score</span>}
                            </p>
                            <>
                                <p className="text-gray-900 font-semibold">Notes :</p>
                                {offer.criteria[index]?.description
                                    ? <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(offer.criteria[index].description) }} />
                                    : <p className="text-red-600 italic">aucune note</p>}
                            </>
                        </Card>
                    )
                    : "")}
            {sumScore > sumPonderation && <p className="text-red-600">Erreur dans la somme des scores : le total est supérieur à la pondération.</p>}
        </div>
    );
}
